import React from "react"
import { Table as AntTable } from "antd"
import { ExtraButtons } from "src/components/extra-buttons"
import { Header } from "src/components/layout/header"
import { VisibilityProvider } from "src/components/visibility-provider"
import { useUpdateHeaderTitle } from "src/hooks/use-update-header-title"
import { usePermission } from "src/hooks"
import { EditDrawer } from "src/pages-lib/points/edit-drawer"
import { useGetPoints, useManageItems } from "src/pages-lib/points/model"
import { getFormattedItems } from "src/pages-lib/points/model/use-get-points"
import { getColumns } from "src/pages-lib/points/table-columns"
import styled from "styled-components"
import {CompassOutlined, FieldTimeOutlined} from "@ant-design/icons";
import {Button} from "../components/actions/button";
import {GeoUpdateDrawer} from "../pages-lib/points/geo-update-drawer";
import {PointFilers} from "../pages-lib/points/filters";
import {TableEditDrawer} from "../pages-lib/points/tabel-edit-drawer";
import {FeedDrawer} from "../pages-lib/points/feed-drawer";
import {MassEditTimeDrawer} from "../pages-lib/delivery-areas";

export default function Points() {
  const { hasPermission } = usePermission()
  const [editDrawerState, setEditDrawerState] = React.useState(false)
  const [geoUpdateDrawerState, setGeoUpdateDrawerState] = React.useState(false)
  const [editTableDrawer, setEditTableDrawer] = React.useState(false)
  const [massEditHurryUpTime, setMassEditHurryUpTime] = React.useState(false)
  const [massEditTable, setMassEditTable] = React.useState(false)
  const [feedPoint, setFeedPoint] = React.useState(null)

  const { items, refetch: getItems, isLoading, pagination, options, handleTableChange, handleSearchTable } = useGetPoints()
  const { editData, editTableData, editTablePointId, onSaveEdit, onEditItem, onUpdateGeo, onEditTableData, onSaveEditTable, onSendMass, fetchPointById } = useManageItems(
    items,
    getItems,
    onSuccessEdit,
    onSuccessGeoUpdate,
    onSuccessEditTable
  )

  const headerTitle = useUpdateHeaderTitle({
    items,
    defaultTitle: "0 Точек",
    arrType: ["Точка", "Точки", "Точек"],
  })

  const canEditPoint = hasPermission("points.edit")
  const canEditWaitingTime = hasPermission("points.edit-waiting-time")
  const canViewPoint = hasPermission("points.view")
  const columns = getColumns(
    canViewPoint || canEditPoint || canEditWaitingTime ? onEditItem : null,
    canEditPoint ? onEditTableData : null,
    !canEditPoint && !canEditWaitingTime,
    canEditPoint ? onEditFeeds : null,
  )

  // Признаки и ссылки фидов правятся отдельно от карточки: у них свои наборы
  // на каждой площадке и собственные запросы на сохранение.
  function onEditFeeds(id) {
    const item = getFormattedItems(items).find((point) => point.id === id)
    setFeedPoint(item ?? null)
  }

  function onSuccessEdit() {
    setEditDrawerState(!editDrawerState)
  }

  function onSuccessGeoUpdate() {
      setGeoUpdateDrawerState(!geoUpdateDrawerState)
  }

   function onSuccessEditTable() {
      setEditTableDrawer(!editTableDrawer)
   }

  return (
    <>
      <Header title={headerTitle} extra={<ExtraButtons />} />
        <ButtonsRowFlex>
            {hasPermission("points.update-delivery-map") && (
                <StyledButton
                    color={"#808080"}
                    onClick={() => setGeoUpdateDrawerState(true)}
                    icon={<CompassOutlined style={{ fontSize: "16px"}}/>}
                >
                    {"Обновить карту доставки" }
                </StyledButton>
            )}

            {(canEditPoint || canEditWaitingTime) && (
                <StyledButton color={"#808080"} onClick={() => setMassEditHurryUpTime(true)} icon={
                    <FieldTimeOutlined style={{ fontSize: "16px"}}/>}>
                    {"Управление временем самовывоза"}
                </StyledButton>
            )}

            {(canEditPoint || canEditWaitingTime) && (
                <StyledButton
                    color={"#808080"}
                    onClick={() => {
                        setMassEditTable(true)
                        setMassEditHurryUpTime(true)
                    }}
                    icon={
                        <FieldTimeOutlined style={{ fontSize: "16px"}}/>
                    }>
                    {"Управление временем столиков"}
                </StyledButton>
            )}
        </ButtonsRowFlex>



      <PointFilers
          handleSearch={ handleSearchTable }
      />

      <StyledTable
        dataSource={getFormattedItems(items)}
        columns={columns}
        pagination={pagination}
        loading={isLoading}
        onChange={handleTableChange}
      />

      <VisibilityProvider visible={Boolean(feedPoint)}>
        <FeedDrawer point={feedPoint} onClose={() => setFeedPoint(null)} />
      </VisibilityProvider>

      <VisibilityProvider visible={editDrawerState}>
        <EditDrawer
          onSave={onSaveEdit}
          onClose={() => setEditDrawerState(!editDrawerState)}
          initialValues={editData}
          title={canEditPoint || canEditWaitingTime ? "Редактирование точки" : "Просмотр точки"}
          readOnly={!canEditPoint && !canEditWaitingTime}
          waitingTimeOnly={!canEditPoint && canEditWaitingTime}
          pointsFeatures={options.pointsFeatures}
          pointCategories={options.pointCategories}
          deliveryTypes={options.deliveryTypes}
          paymentTypes={options.paymentTypes}
          paymentAccounts={options.paymentAccounts}
        />
      </VisibilityProvider>

        <VisibilityProvider visible={geoUpdateDrawerState}>
            <GeoUpdateDrawer
                onSave={onUpdateGeo}
                onClose={() => setGeoUpdateDrawerState(!geoUpdateDrawerState)}
                title={"Обновление данных по зонам доставки"}
                cityOptions={options.cityOptions}
            />
        </VisibilityProvider>

        <VisibilityProvider visible={editTableDrawer}>
            <TableEditDrawer
                onSave={onSaveEditTable}
                onClose={() => setEditTableDrawer(!editTableDrawer)}
                title={"Добавить редактировать столики точки"}
                initialData={editTableData}
                pointId={editTablePointId}
            />
        </VisibilityProvider>

        <VisibilityProvider visible={massEditHurryUpTime}>
            <MassEditTimeDrawer
                title={`Управление интервалом 'поскорее' ${massEditTable ? "столов" : "самовывоза"} `}
                onClose={() => {
                    setMassEditTable(false)
                    setMassEditHurryUpTime(false)
                }}
                isPickUp={true}
                onSave={onSendMass}
                pointOption={options.pointOptions}
                fetchPointById={fetchPointById}
                isTable={massEditTable}
            />
        </VisibilityProvider>
    </>
  )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`

const StyledButton = styled(Button)`
    margin: 10px 0 20px 0 ;
`;

const ButtonsRowFlex = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
`

